"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4395],{

/***/ 34395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionFeaturedBlogPosts": function() { return /* binding */ SectionFeaturedBlogPosts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61349);




const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingInline: 20,
    "@xl": {
        paddingInline: 30
    }
});
const Heading = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading02",
    color: "$white",
    textAlign: "center",
    marginBottom: "$96",
    "@xl": {
        marginBottom: "$120"
    }
});
const CardLink = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
    pointerEvents: "all",
    zIndex: "$cardButton",
    width: "max-content"
});
const CardsWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 30,
    marginBottom: "$40",
    "@xl": {
        gridTemplateColumns: "repeat(3, 1fr)"
    },
    "@media (min-width: 1522px)": {
        gridTemplateColumns: "unset",
        gridAutoFlow: "column",
        gridAutoColumns: 486
    }
});
const Article = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    position: "relative",
    width: "100%",
    color: "$white",
    height: "100%",
    display: "grid",
    alignItems: "start",
    gridTemplateRows: "auto 1fr"
});
const ArticleTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h3", {
    projectFont: "heading07",
    gridRow: 2,
    gridColumn: 1,
    color: "$white"
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    gridColumn: 1,
    gridRow: 1,
    borderRadius: "$r2",
    overflow: "hidden",
    transition: "transform .5s ease",
    "& img": {
        transition: "transform .5s ease"
    },
    "@md": {
        "&:hover": {
            "& img": {
                transform: "scale(1.04)"
            }
        }
    }
});
const ArticleTags = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gridColumn: 1,
    gridRow: 1,
    columnGap: "$12"
});
const ArticleTag = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gap: "$10"
});
const ArticleGridContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    position: "relative",
    display: "grid",
    rowGap: "$24",
    width: "100%",
    paddingTop: "$20",
    "@md": {
        rowGap: "$32",
        height: "100%",
        gridTemplateRows: "auto auto 1fr"
    }
});
const StyledLink = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
    zIndex: "$content",
    projectFont: "heading08",
    textDecoration: "underline",
    gridColumn: 1,
    gridRow: 3,
    textUnderlineOffset: ".35em",
    color: "$white",
    display: "grid",
    height: "100%",
    alignItems: "end"
});
const SectionFeaturedBlogPosts = (param)=>{
    let { title , featuredArticles , priority , ctaLabel , ctaLink , spacing , topBorder  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("articles");
    const ctaHref = ctaLink && (0,_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .isLinkHref */ .mL)(ctaLink) && ctaLink.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: spacing || "DEFAULT",
        topBorder: topBorder,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsWrap, {
                children: featuredArticles === null || featuredArticles === void 0 ? void 0 : featuredArticles.map((param)=>/*#__PURE__*/ {
                    let { id , link , image , title , tags  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Article, {
                        children: [
                            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: link,
                                tabIndex: -1,
                                "aria-label": "Article - ".concat(title),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                                        ...image,
                                        hardcropRatio: "landscape3",
                                        priority: priority,
                                        sizes: "(min-width: 740px) 50vw, 100vw"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ArticleGridContent, {
                                children: [
                                    tags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleTags, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleTag, {
                                            children: tags.map((tag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Chip */ .Af, {
                                                    title: tag.title,
                                                    type: "light",
                                                    href: tag.path
                                                }, tag._id))
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleTitle, {
                                        children: title
                                    }),
                                    link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                        href: link,
                                        appearance: "text",
                                        children: t("readArticle")
                                    })
                                ]
                            })
                        ]
                    }, id);
                })
            }),
            ctaHref && ctaLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardLink, {
                appearance: "containedTransparent",
                href: ctaHref,
                children: ctaLabel
            })
        ]
    });
};


/***/ })

}]);